import React, { useMemo } from "react";
import Heart from "../heart";
import CountDown from "../CountDown";
import { BookHelper } from "../../helpers/book";

export default function CartItem({ item, inPayment, rewardLevel }) {
    const discountQuantity = useMemo(() => BookHelper.getBookDiscount(item["discount_type"] ?? 1, item.price, item.oldprice, item["discount_quantity"]), [item]);
    const isPriceCapped = useMemo(() => item["is_price_capped"], [item]);

    let pointsIconSrc = "/images/icon/customer-discount/none-dibook.svg";
    let badgeIconSrc = "/images/icon/customer-discount/none-dibook.svg";
    let badgeTextColor = "#000"; // Alapértelmezett szín, ha nincs reward level
    
    if (rewardLevel === 1) {
        pointsIconSrc = "/images/icon/customer-discount/bronz-dibook.svg";
        badgeIconSrc = "/images/icon/customer-discount/bronz.svg";
        badgeTextColor = "#663C14"; // Bronz szín
    } else if (rewardLevel === 2) {
        pointsIconSrc = "/images/icon/customer-discount/ezust-dibook.svg";
        badgeIconSrc = "/images/icon/customer-discount/ezust.svg";
        badgeTextColor = "#606665"; // Ezüst szín
    } else if (rewardLevel === 3) {
        pointsIconSrc = "/images/icon/customer-discount/arany-dibook.svg";
        badgeIconSrc = "/images/icon/customer-discount/arany.svg";
        badgeTextColor = "#665600"; // Arany szín
    } else if (rewardLevel === 4) {
        pointsIconSrc = "/images/icon/customer-discount/platina-dibook.svg";
        badgeIconSrc = "/images/icon/customer-discount/platina.svg";
        badgeTextColor = "#2D1C66"; // Platina szín
    }

    return (
        <div className="new-cart-list-item flex-wrap">
            {item["discount_type"] && (
                <div
                    className={
                        "cart-list-item__label" +
                        (item["discount_type"]
                            ? ` cart-list-item__label--${item["discount_type"]}`
                            : "")
                    }
                >
                    <div className="cart-list-item__label__text">
                        {discountQuantity}
                        <span className="cart-list-item__label__postfix">
                            {item["discount_postfix"].trim()}
                        </span>
                    </div>
                </div>
            )}
            {item.countdown && <CountDown initialCountDown={item.countdown} />}
            <a href={item.url} className="cart-list-item-img" style={{ position: 'relative' }}>
                {item.type === "voucher" ? (
                    <img
                        src={`/images/voucher/${(item.oldprice ?? item.price)}-voucher-nov-2024.png`}
                        alt={item.title}
                    />
                ) : (
                    <>
                        <img src={item.cover} alt={item.title} />

                        {/* Badge ikon a bal felső sarokban, kedvezmény százalékkal */}
                        {rewardLevel > 0 && item.categoryDiscount &&  (
                            <div style={{
                                position: 'absolute',
                                top: '-0.8rem',
                                left: '-0.8rem',
                                width: '40%',
                                maxWidth: '40px',
                                minWidth: '20px',
                                textAlign: 'center'
                            }}>
                                <img
                                    src={badgeIconSrc}
                                    alt="Discount Badge"
                                    style={{
                                        width: '100%',
                                        height: 'auto',
                                    }}
                                />
                                {/* Kedvezmény százalékos érték megjelenítése a badge-en */}
                                <span style={{
                                    position: 'absolute',
                                    top: '50%',
                                    left: '50%',
                                    transform: 'translate(-50%, -50%)',
                                    color: badgeTextColor, // Szöveg színe (módosítható a kontraszt miatt)
                                    fontWeight: 'bold',
                                    fontSize: '0.8em'
                                }}>
                                    {discountQuantity}%
                                </span>
                            </div>
                        )}
                    </>
                )}
            </a>
            <div className="cart-list-item-content">
                <div className="cart-list-item-info">
                    <div className="d-flex flex-column" style={{ gap: 10 }}>
                        <div className="cart-list-item-title">
                            <a href={item.url}>{item.title}</a>
                        </div>
                        <div className="cart-list-item-author">
                            {item.author?.map((authorItem, index) => (
                                <a href={authorItem.url} key={index}>
                                    {authorItem.name}
                                    <br />
                                </a>
                            ))}
                        </div>
                    </div>
                    {isPriceCapped ? <div className="cart-price-capped-tag">
                        <p>ÁRKÖTÖTT</p>
                    </div> : null}
                    <div className="cart-list-item-price">
                        {item.oldprice && (
                            <span className="cart-list-item-old-price">
                                {window.Dibook.language.formatCurrency(item.oldprice)}
                            </span>
                        )}
                        {(item.type != "voucher") &&(<span className="cart-list-item-new-price">
                            {window.Dibook.language.formatCurrency(item.price)}
                        </span>)}
                        
                        {(item.type === "voucher") && (<span className="cart-list-item-new-price">
                            {window.Dibook.language.formatCurrency(item.price)}
                            {item.oldprice ? <img className="order-voucher-price-img" src={pointsIconSrc} alt="Pont ikon" /> : null}
                        </span>)}

                        {(item.points > 0 && !item.noPoints && item.points > item.originalPoints && [1,2].includes(item.type_num)) && (
                            <span className="cart-list-item-original-points">{item.originalPoints} pont<br/></span>
                        )}
                        {(item.points > 0 && !item.noPoints && item.originalPoints <= item.points && [1, 2].includes(item.type_num)) && (
                            <span className="cart-list-item-points">
                                <img className="order-total-points-img" src={pointsIconSrc} alt="Pont ikon" />
                                {item.points} pont
                            </span>
                        )}
                    </div>
                    <div className="cart-list-item-extra-mobile">
                        {item.type === "ebook" ? (
                            <img src="/images/icon/new-e-book.svg" alt="e-book-icon" />
                        ) : (
                            <img src="/images/icon/new-audiobook.svg" alt="audiobook-icon" />
                        )}
                        <Heart id={item.id} type={"book"} wishlist={true} />
                        {!inPayment && <div className="remove-cart-btn" data-id={item.id}></div>}
                    </div>
                </div>
                <div className="cart-list-item-extra">
                    <div className="d-flex flex-column" style={{ gap: 10 }}>
                        <div style={{ height: 27 }} />
                        <div className="cart-list-item-type">
                            {(item.type === "ebook" || item.type == "package-ebook") ? (
                                <img src="/images/icon/new-e-book.svg" alt="e-book-icon" />
                            ) : (
                            (item.type === "audio" || item.type == "package-audio") && (
                                <img src="/images/icon/new-audiobook.svg" alt="audiobook-icon" />
                            )
                            )}
                        </div>
                    </div>
                    <div className="cart-list-item-action flex-nowrap">
                        {(item.type === "audio" || item.type === "ebook") && <Heart id={item.id} type={"book"} wishlist={true} />}
                        {!inPayment && <div className="remove-cart-btn" data-id={item.id}></div>}
                    </div>
                </div>
            </div>
        </div>
    );
}
